import React from 'react'
import './CourierInfoComponent.css'

const CourierInfoComponent = () => {

    const data = [
        {
            label: "Courier",
            value: "Shiprocket"
        },
        {
            label: "Tracking ID",
            value: "81968498463"
        },
        {
            label: "Order ID",
            value: "J4672554"
        },
        {
            label: "Order Type",
            value: "PREPAID"
        },
        {
            label: "Last Update",
            value: "Delivered on 9th Feb, 07:34pm"
        },

    ]

    return (
        <section className='CourierInfoComponent'>

            {data?.map((item) => {
                return (
                    <div className='row_holder'>
                        <div className='label_holder'>
                            <p className='lebel'>
                                {item?.label}
                            </p>
                        </div>

                        <div className='value_holder'>
                            <p className='value'>
                                {item?.value}
                            </p>
                        </div>
                    </div>
                )
            })}


        </section>
    )
}

export default CourierInfoComponent
